<template>
    <div class="main-body">
        <div class="header">
            用户消费订单统计
        </div>
        <div class="out">
            <div class="search2">
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search">
                <template slot="daterange">
                    <Daterange :startTime="searchForm.startTime" :endTime="searchForm.endTime" @dataChange='dataChange'></Daterange>
                </template>
                </Search>
                <div style="clear: both;"></div>
            </div>


          <el-table class="table" size="mini" v-loading="loading" :data="tableData"
                    :height="th" border style="width: 100%;">
            <el-table-column prop="name" label="姓名" ></el-table-column>
            <el-table-column prop="phone" label="联系电话" ></el-table-column>
            <el-table-column prop="idCard" label="身份号" ></el-table-column>
            <el-table-column prop="totalPrice" label="消费金额(元)" :formatter="totalPrices" ></el-table-column>
<!--            <el-table-column prop="balance" label="余额(元)" ></el-table-column>-->
            <el-table-column prop="orderCount" label="订单数量" ></el-table-column>

            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
              </template>
            </el-table-column>

          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>

        <Info ref="myInfo" v-show="showModalInfo"  v-bind:areaValue="areaValue"  v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>

    </div>
</template>

<script>

    import {timeStr,getMonthDay} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Info from "./Info";
    import {getStaffCode} from "@/utils/auth";
    import Search from "@/components/Search";
    import Daterange from "@/components/Daterange";

    export default {
        name: "Role",
        data(){
            return{
                orderTypeList: [
                  {
                    value: -1, label: '全部订单'
                  }, {
                    value: 1, label: '普通商品订单'
                  }, {
                    value: 2, label: '单独服务订单'
                  },
                  {
                    value: 3, label: '合并服务订单'
                  },
                ],
                loading:false,
                businessList:[],
                showModalAdd:false,
                showModalInfo:false,
                tableData:null,
                zoneValue:[],
                areaValue:[],
                datetimerangeValue:'',
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                zoneCode:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                searchData:[],
                searchForm:{
                    name: '',
                    orderType:-1,
                    startTime:'',
                    endTime:'',
                    businessCode:''
                },
            }
        },
        components:{
            Info,Search,Daterange
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.searchData=[
          {span:12,name:'老人姓名',value:'name',type:'input'},
          {span:12,name:'订单类型',value:'orderType',type:'select',options:this.orderTypeList},
          {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
          {span:12,name:'商家',value:'businessCode',type:'select',options:this.businessList},
      ]
      this.searchForm.endTime = getMonthDay("e",0);
      this.searchForm.startTime = getMonthDay("s",0);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Business/ListForGov",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                       this.businessList = response.data.data;
              var  businessList=[];
              businessList.push({label:'全部商家',value:''})
              for (let i in this.businessList){
                let j={label:this.businessList[i].businessName ,value:this.businessList[i].businessCode }
                businessList.push(j)
              }

              this.searchData[3].options=businessList;
              this.$refs.Search.getWidth()
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
            },
            handleInfo(index, row) {
                this.$refs.myInfo.init(row,this.searchForm);
                this.showModalInfo = !this.showModalInfo;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },
            closeInfo:function(){
                this.showModalInfo = !this.showModalInfo;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            totalPrices(row){
                if(!row.totalPrice){
                    return 0;
                }else{
                    var str =row.totalPrice
                    return parseFloat(str).toFixed(2);
                }
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            searchGetList(){
                this.getList();
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1


              let that = this;
                that.loading = true;

                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetConsumerUsers",
                    data: data
                }).then( (response)=> {
                    console.log(response);
                  that.loading = false;

                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                  that.loading = false;
                    console.log(error);
                });
            },
            dataChange(val) {
      this.searchForm.startTime = val[0]
      this.searchForm.endTime = val[1]
    },



        }
    }
</script>

<style scoped>

</style>
